export default function isForeseeLink(_ref) {
  var linkId = _ref.linkId,
      displayType = _ref.displayType;
  return 'FOOTER_FEEDBACK' === linkId || 'FORESEE' === linkId || 'foresee' === displayType;
}